import type { DiscountType } from '../enums/DiscountType'

export class DiscountOfferMiniEntity {
  id?: number;
  name?: string | null;
  type?: DiscountType;
  value?: number;
  maxDiscountAllowed?: number;
  minCartAmount?: number | null;
  startDate?: string;
  endDate?: string;
  createdAt?: string;
  firstPurchase?: boolean | null;
  serviceRatio?: number;
  branchRatio?: number;
  usersCount?: number;
  categoriesCount?: number;
  branchId?: number;
  branchName?: string | null;
  isActive?: boolean;
}
